export default __webpack_public_path__ + "static/media/megane-rs-medium1.7088faae.jpg";